import { useQuery, useMutation } from 'react-query';
import axiosClient from './axiosClient';

export const menuApi = {
    getAll(params) {
        return axiosClient.get('/menu-general', { params })
    },
    create(data) {
        return axiosClient.patch('/menu-general-create', data)
    },
    getById(id, params) {
        return axiosClient.get(`/menu-general/${id}`, { params }).then(res => {
            return res.data || null;
        })
    },
    update(id, data) {
        console.log(id, data)
        return axiosClient.patch(`menu-general-update/${id}`, data)
    }
}

export const useMenus = ({ params, options } = {}) => {
   return useQuery({
    queryKey: ['menu-general', 'list', params],
    queryFn: () => menuApi.getAll(params),
    ...options
   })
}

export const useCreateMenu = () => {
    return useMutation(menuApi.create)
}

export const useMenu = ({id, params, options } = {}) => {
    return useQuery({
     queryKey: ['menu-general', 'details', id, params],
     queryFn: () => menuApi.getById(id, params),
     ...options
    })
 }

export const useUpdateMenu = (id) => {
    return useMutation(data => menuApi.update(id, data))
}